import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/inbox')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/inbox']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
